import type { CSSProperties, ReactNode } from "react";

import { TinsmithMark } from "@tinsmith/brand";

import styles from "./EmptyState.module.css";
import { cx } from "../lib/cx";

export type EmptyStateProps = {
  readonly action?: ReactNode;
  readonly body: ReactNode;
  readonly className?: string;
  readonly markSize?: number;
  readonly style?: CSSProperties;
  readonly title: string;
};

export const EmptyState = ({
  action,
  body,
  className,
  markSize = 72,
  style,
  title,
}: EmptyStateProps) => (
  <div className={cx(styles.empty, className)} style={style}>
    <div className={styles.mark}>
      <TinsmithMark size={markSize} />
    </div>
    <div className={styles.title}>{title}</div>
    <div className={styles.body}>{body}</div>
    {action ? <div className={styles.action}>{action}</div> : null}
  </div>
);
